import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Row, Paragraph, colors, useContainerWidth, Cell, LayoutBand, Separator } from '@fs/zion-ui'
import { TreeAppButtons } from '@fs/zion-mobile-app-buttons'

export default function AppDownloadSectionTop(): JSX.Element {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <LayoutBand marginY="md" marginX={atWidth({ default: 'sm', xl: 'xxl' })} maxWidth="xl">
      <Row alignX="center">
        <Card backgroundColor={colors.green05} edges="elevation" margins="md" maxWidth={1000}>
          <Row gutters="lg" wrap={atWidth({ default: true, xl: false })} alignY="middle">
            {/* Text content - grows to fill available space on desktop */}
            <Cell growX>
              <Paragraph size="sm">
                <strong>
                  {t(
                    'tree-overview.family-interview.tip.heading',
                    'Tip: Use the free Family Tree app to record the responses during your interview.'
                  )}
                </strong>
              </Paragraph>
              <Paragraph size="sm">
                {t(
                  'tree-overview.family-interview.tip.description',
                  "This allows you to preserve an audio recording of your family member's voice while capturing their stories - a precious memory that future generations will treasure."
                )}
              </Paragraph>
            </Cell>
            <Cell noShrinkX>
              <Paragraph centered={atWidth({ xl: true })} size="md">
                <strong>{t('tree-overview.family-interview.tip.download-heading', 'Download the App')}</strong>
              </Paragraph>
              <Separator size="xs" />
              <TreeAppButtons stacked={atWidth({ default: true, xl: false })} centered={atWidth({ xl: true })} />
            </Cell>
          </Row>
        </Card>
      </Row>
    </LayoutBand>
  )
}
